import { render, staticRenderFns } from "./slider.slick.vue?vue&type=template&id=c38a837a&scoped=true&"
import script from "./slider.slick.vue?vue&type=script&lang=js&"
export * from "./slider.slick.vue?vue&type=script&lang=js&"
import style0 from "./slider.slick.vue?vue&type=style&index=0&id=c38a837a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38a837a",
  null
  
)

export default component.exports